export default "__VITE_ASSET__419b1d57__"